import { render, staticRenderFns } from "./editProductSpec.vue?vue&type=template&id=6b0b4915&scoped=true"
import script from "./editProductSpec.vue?vue&type=script&lang=js"
export * from "./editProductSpec.vue?vue&type=script&lang=js"
import style0 from "./editProductSpec.vue?vue&type=style&index=0&id=6b0b4915&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0b4915",
  null
  
)

export default component.exports